import AutoSizer from "react-virtualized-auto-sizer";
import CachedIcon from '@mui/icons-material/Cached';
import { blobToURL, urlToBlob, fromBlob, fromURL } from 'image-resize-compress';
import CompressIcon from '@mui/icons-material/Compress';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import SnippetFolderIcon from '@mui/icons-material/SnippetFolder';
import Box from '@mui/material/Box';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import prettyBytes from 'pretty-bytes';
import { useEffect, useRef, useState } from 'react';
import { Button, Loading } from 'react-admin';
import fetchJson from 'utils/fetchJson';
import { useMultiSelectionContext } from 'utils/providers/MultiSelectionProvider';
import { useFileManagerModalInputDialogContentContext } from './FileManagerModalInputDialogContentProvider';
import { FmFile } from './types';
import QrCodeLogoInput from '../QrCodeLogoInput';
import { FixedSizeList } from 'react-window';

interface FileManagerModalInputDialogListProps {
}

const FileManagerModalInputDialogList = (_props: FileManagerModalInputDialogListProps) => {
  const { group, search, sub, setSub, isThumbnailView, _lastListTime } = useFileManagerModalInputDialogContentContext();
  const [files, setFiles] = useState<Array<FmFile>>([]);
  const [fileShowings, setFileShowings] = useState<Array<FmFile>>([]);
  const { selection, addSelection } = useMultiSelectionContext();
  const [isLoading, setIsLoading] = useState(false);
  const [height, setHeight] = useState(400);
  const myDiv = useRef<HTMLDivElement>();

  const doReload = async () => {
    setIsLoading(true);
    return fetchJson(`/api/file-system/list/${group}?sub=${sub.join('/')}`, {})
      .then(x => {
        setFiles(x.json.files);
        setIsLoading(false);
      })
      .catch(err => console.warn(err));
  }

  useEffect(() => {
    const onResize = () => {
      if (myDiv.current) {
        setHeight(myDiv.current.getBoundingClientRect().height - 48 - (0 === sub.length ? 0 : 48));
      }
      // setHeight(window.innerHeight)
    }
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize);
  }, []);

  useEffect(() => {
    // console.log(1);
    setTimeout(() =>  {
    if (myDiv.current) {
        setHeight(myDiv.current.getBoundingClientRect().height - 48 - (0 === sub.length ? 0 : 48));
    }
  }, 100);
  }, [myDiv.current]);

  useEffect(() => {
    doReload()
  }, [group, sub, _lastListTime]);

  useEffect(() => {
    if ('' === search) {
      setFileShowings(files)
    } else {
      setFileShowings(files.filter(x => -1 !== x.name.indexOf(search)))
    }
  }, [files, group, search])

  if (fileShowings.length === 0) {
    if ('' === search) {
      return <Typography variant="body2" component="span">No files</Typography>;
    } else {
      return <Typography variant="body2" component="span">No files matching '{search}'</Typography>;
    }
  }

  const handleUpClick = () => {
    setSub((o: Array<string>) => {
      o.pop();
      return [...o];
    });
  }

  const handleItemClick = (f: FmFile) => {
    // console.log('', 'handleItemClick', f);
    if (f.is_dir) {
      // console.log(1234);
      setSub((o: Array<string>) => [...o, f.name]);
    } else {
      addSelection(f, false);
    }
  }

  const onCompressClick = (f: FmFile) => {
    const imageUrl = `${f.src}`;
    const quality = 90;
    const width = 'auto';
    const height = 'auto';
    const format = f.src.split('.').pop() as string;
    if (-1 !== ['jpg', 'png', 'jpeg', 'webp'].indexOf(format)) {
      fromURL(imageUrl, quality, width, height).then((resizedBlob: any) => {
        // console.log('resizedBlob', resizedBlob, f);
        const formData = new FormData();
        formData.append('files[]', resizedBlob, f.name);
        fetch(`/api/file-system/upload/${group}?sub=${sub.join('/')}`, { method: 'POST', body: formData }).then(() => {
          doReload();
          alert('Compress & Replaced');
          // doReload();
          // reload();
          // setList([]);
        });
      });
    } else {
      alert("File extension not supported");
    }
  }

  const onDeleteClick = (f: FmFile) => {
    // console.log('onDeleteClick', f);
    if (window.confirm(`Are you sure to delete the item?`)) {
      setIsLoading(true);
      fetchJson(`/api/file-system/delete/${group}?sub=${sub.join('/')}&basename=${f.name}`, { method: 'DELETE', body: JSON.stringify(f) })
        .then(x => {
          // setFiles(x.json.files);
          // console.log(x);
          doReload();
        })
        .catch(err => console.warn(err));
    }
  }

  if (isLoading) {
    return <Loading />
  }

  return (
    <div ref={myDiv} style={{ height: '100%', position: 'relative' }}>
      <Button label="Reload" variant="outlined" sx={{ marginLeft: `10px` }}><CachedIcon /></Button>
      {isThumbnailView
        ? <Box sx={{ flexGrow: 1, padding: "0 10px" }}>
          <Grid container spacing={1}>
            {0 === sub.length
              ? null
              : <Grid item xs={6} sm={3} md={2}>
                <div style={{ paddingBottom: "100%", display: "block", position: "relative", cursor: 'pointer' }} onClick={() => handleUpClick()}>
                  <DriveFolderUploadIcon />
                </div>
              </Grid>
            }
            {fileShowings.map((file, fileIndex) => (
              <Grid key={`${fileIndex}_${file.name}`} item xs={6} sm={3} md={2}>
                <div style={{ paddingBottom: "100%", display: "block", position: "relative", cursor: 'pointer' }} onClick={() => handleItemClick(file)}>
                  {file.is_dir
                    ? <SnippetFolderIcon />
                    : <>
                      <CardMedia
                        component={"img"}
                        style={{ position: "absolute", left: 0, top: 0, height: "100%", objectFit: "scale-down" }}
                        src={file.src}
                      />
                      <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, background: -1 !== selection.indexOf(file) ? "rgba(0,0,0,.4)" : "transparent" }}>
                        {-1 !== selection.indexOf(file)
                          ? <CheckBoxIcon />
                          : <CheckBoxOutlineBlankIcon />
                        }
                      </div>
                      <div style={{ position: "absolute", bottom: 0, width: "100%", height: "50px", background: "rgba(0,0,0,.8)", color: 'white' }}>
                        <div style={{ display: 'flex' }}>
                          <div style={{ flex: 3, overflow: "hidden", }}>
                            <p style={{ overflow: 'hidden', padding: "0 0 0 3px", margin: 0 }}>{file.name}</p>
                            <p style={{ overflow: 'hidden', padding: "0 0 0 3px", margin: 0 }}>{prettyBytes(file.size)}</p>
                          </div>
                          <div style={{ display: 'flex' }}>
                            <IconButton sx={{ color: 'rgba(255, 255, 255, 0.54)' }} aria-label={`info about ${file.name}`} onClick={() => window.open(file.src)}>
                              <OpenInNewIcon />
                            </IconButton>
                          </div>
                        </div>
                      </div>
                    </>
                  }
                </div>
              </Grid>
            ))}
          </Grid>
        </Box>
        : <List>
          {0 === sub.length
            ? null
            : <ListItem disablePadding>
              <ListItemButton onClick={() => handleUpClick()}>
                <ListItemIcon>
                  <DriveFolderUploadIcon />
                </ListItemIcon>
                <ListItemText primary={'..'} />
              </ListItemButton>
            </ListItem>
          }
          <FixedSizeList
            height={height}
            itemCount={fileShowings.length}
            itemSize={48}
            width='100%'
            itemData={fileShowings}
          >
            {({ index, style, data }) => {
              let f = data[index] as FmFile;
              let fileIndex = index;
              {/* console.log(f); */ }
              return (
                <ListItem
                  style={style}
                  key={`${fileIndex}_${f.name}`}
                  secondaryAction={
                    <>
                      {f.is_dir ? <small>Inside: {f.child_count}</small> : <small>{prettyBytes(f.size)}</small>}
                      {f.is_dir ? null : <IconButton title="Compress" aria-label="compress" onClick={() => onCompressClick(f)}><CompressIcon /></IconButton>}
                      {f.is_dir ? null : <QrCodeLogoInput buttonOnly defaultValue={`https://www.spga.org.hk${f.src}`} />}
                      {f.is_dir ? null : <IconButton title="Popup" aria-label={`info about ${f.name}`} onClick={() => window.open(f.src)}><OpenInNewIcon /></IconButton>}
                      <IconButton title="Delete" edge="end" aria-label="delete" onClick={() => onDeleteClick(f)}><DeleteIcon /></IconButton>
                    </>
                  }
                  disablePadding
                >
                  <ListItemButton
                    key={f.name}
                    selected={-1 !== selection.indexOf(f)}
                    onClick={() => handleItemClick(f)}
                  >
                    <ListItemIcon>
                      {f.is_dir
                        ? <SnippetFolderIcon />
                        : (-1 !== selection.indexOf(f))
                          ? <CheckBoxIcon />
                          : <CheckBoxOutlineBlankIcon />
                      }
                    </ListItemIcon>
                    <ListItemText primary={f.name} />
                  </ListItemButton>
                </ListItem>)
            }}
          </FixedSizeList>
        </List>
      }
    </div>
  )
}

export default FileManagerModalInputDialogList;
